<template>
	<main class="dad u__text-center content">
		<template v-for="(image, index) in images">
			<div
				v-if="isVideo(image.name)"
				:class="[
					'photo',
					'filter',
					{ firstbigpic: index === 0 && $route.path === '/' }
				]"
				:key="image.id"
			>
				<video muted loop playsinline autoplay :controls="false" :preload="true">
					<source :src="$getImgUrl(image.name)" type="video/mp4" />
				</video>
				<a class="movie" @click.prevent="YouTubePopUp(image.link)">
					<div class="link"></div>
					<div class="uptext">{{ image.upText }}</div>
					<div class="horizontal"></div>

					<div v-if="image.text1 && image.text2" class="downtext2">
						{{ image.text1 }}<br />{{ image.text2 }}
					</div>
					<div v-else-if="!image.text1" class="downtext">
						{{ image.text2 }}
					</div>
					<div v-else class="downtext">
						{{ image.text1 }}
					</div>
				</a>
			</div>

			<div
				v-else
				:class="[
					'photo',
					'filter',
					{ firstbigpic: index === 0 && $route.path === '/' }
				]"
				:style="[
					{ background: 'url(' + $getImgUrl(image.name) + ')' },
					{ 'background-size': 'cover' },
					{ 'background-repeat': 'no-repeat' }
				]"
				:key="image.id"
			>
				<a class="movie" @click.prevent="YouTubePopUp(image.link)">
					<div class="link"></div>
					<div class="uptext">{{ image.upText }}</div>
					<div class="horizontal"></div>

					<div v-if="image.text1 && image.text2" class="downtext2">
						{{ image.text1 }}<br />{{ image.text2 }}
					</div>
					<div v-else-if="!image.text1" class="downtext">
						{{ image.text2 }}
					</div>
					<div v-else class="downtext">
						{{ image.text1 }}
					</div>
				</a>
			</div>
		</template>
	</main>
</template>
<script>
import { YouTubePopUp } from '@/plugins/YouTubePopUp'

export default {
	props: {
		filter: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		YouTubePopUp
	}),
	computed: {
		images: ({ $store, filter }) =>
			filter
				? $store.getters['image/data'].filter((item) => item.filter === filter)
				: $store.getters['image/data']
						.filter((item) => item.filter !== 'hidden')
						.filter((item) => item.filter !== 'project')
	},
	methods: {
		isVideo: (name) =>
			name.split('.')[1] === 'mp4' || name.split('.')[1] === 'mov' ? true : false
	}
}
</script>
